import type { RouteObject } from "react-router-dom";
import RegistrationPage, { registrationLoader } from "./Registration";
import GstSummaryPage from "./GstSummary";
import AppError from "../app-error";
import NumberRouteError from "./number-route-error";

/**
 * Registration and GST summary. GST summary has its own NAV entry (`billing.read`), which gates
 * it. Registration has none: it self-gates in its loader (read for `billing.read`,
 * `dispatch.assign` or `billing.administer`; its actions for `billing.administer` only) and is
 * reached from the invoice detail header and the invoice list's row menu.
 */
export const invoicingRegistrationRoutes: RouteObject[] = [
  { path: "invoicing/:invoiceNumber/registration", Component: RegistrationPage, loader: registrationLoader, errorElement: <NumberRouteError /> },
  { path: "invoicing/gst-summary", Component: GstSummaryPage, errorElement: <AppError /> },
];
